<template>
  <div>
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <!-- <img class="bannerImg" src="../img/announcement.jpg" /> -->
        </div>
      </a-carousel>
    </div>
    <div style="width: 100%;background-color: #fff;">
      <div class="breadBox">
        <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png" />
            当前位置：
          </span>
          <a-breadcrumb-item  style="cursor:pointer" @click="$router.push({ path: '/finance/index'})">首页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="tabBox">
        <a-list class="activeRightImg" item-layout="vertical" size="large" :pagination="pagination" :data-source="policyData">
          <template #renderItem="{ item }">
            <div class="listBox" @click="onpolicyDetail(item.id)">
              <!-- <div class="leftBox">
                <img :src="getImg(item.thumbnail)" alt="">
              </div> -->
              <div class="right">
                <div class="right-top">
                  <h1>{{momentFormat(item.publishTime,'DD')}}</h1>
                  <p style="margin-left: 8px;">{{momentFormat(item.publishTime,'YYYY-MM')}}</p>
                </div>
                <div class="right-cont">
                  <div class="title">{{ item.title }}</div>
                  <div class="content">{{ item.contentAbstract }}</div>
                </div>
              </div>
              <a-divider dashed />
            </div>
          </template>
        </a-list>
      </div>
    </div>
  </div>
</template>
<script>
import { policyWeb } from "@/api/innovationService";
import { file_service } from "@/api/adminService";


const pagination = {
  pageSize: 10,
  showQuickJumper: true,
};
export default {
  name: 'consultation',
  components: {
  },
  mounted() {
    this.getPolicyList()
    this.title = this.$route.query.type,
        this.activeKey = this.$route.query.activeKey
  },
  data() {
    return {
      pagination,
      policyData: [],
      current: 1,
      pageSize: 10,
      title: '',
        activeKey:"1"
    }
  },
  methods: {
    getPolicyList() {
      this.getAction({
        url: policyWeb.pageList,
        params: { systemType: 'finance' }
      }).then(res => {
        this.policyData = res.records
      })
    },
    //法律法规详情
    onpolicyDetail(id) {
      this.$router.push({
        path: "/finance/law/page",
        query: { id: id ,type:"法律法规详情"}
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>
<style scoped lang="less">
:deep(.ant-list-pagination){
  margin-bottom: 16px;
  clear:both;
  
  float:right
}
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }

  .showMoreButton {
    position: absolute;
    top: 55%;
    left: 21.5%;
    width: 170px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background-color: #0048c4;
    color: #fff;
    cursor: pointer;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.tabBox {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 20px 0;
  display: flex;
  .listBox {
    overflow: hidden;
    padding: 10px 0;
    cursor: pointer;

    .leftBox {
      float: left;
      width: 24%;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      display: flex;
      width: 74%;
      font-size: 14px;
      .right-top{
        h1{
          text-align: center;
        }
      }
      .right-cont{
        margin-left: 40px;
      }

      .title {
        padding: 10px 0;
        font-size: 20px;
        color: #333;
        font-weight: 500;
      }

      .content {
        overflow: hidden;
        margin: 10px 0;
        color: #666;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .time {
        padding: 10px 0;
        color: #999;
      }
    }
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab) {
    font-size: 14px;
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active) {
    color: #fff;
    background-color: #1890ff;
  }
  .activeRightImg{
    flex: 1;
  }
  .activityContent {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .activityLi {
      width: 23%;
      margin: 20px 0;
      cursor: pointer;

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 10px;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;

      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
}
</style>
